import Vue from 'vue';

Vue.component('outlet-central-settings-index', () =>
    import(/* webpackChunkName: 'outlet-central-settings-index' */ './outlet-central-settings-index'),
);
